module.exports = __webpack_public_path__ + "img/kumo_white_2.525dbc1f.svg";